import { getSetting, getSettingLabel } from '@koob/utils';
import { ProgramAccommodationTypeEnum } from '@koob/enums';

export default function ExportDayHotelFallback({
  accommodationType,
  settings,
}) {
  const daysSection = getSetting(settings, 'days');
  const accommodationSubsection = getSetting(
    daysSection?.sections,
    'accommodation',
  );

  const bookedOutside =
    accommodationType === ProgramAccommodationTypeEnum.BOOKED_ON_MY_OWN;

  const message = getSettingLabel(
    accommodationSubsection?.fields,
    bookedOutside ? 'accom-booked-outside' : 'accom-no-accommodation',
  );
  const description = bookedOutside
    ? getSettingLabel(
        accommodationSubsection?.fields,
        'accom-booked-outside-description',
      )
    : null;

  return (
    <div
      className="relative flex items-start gap-4 rounded-sm bg-[var(--td-paper-secondary)] p-4 ring-1 ring-inset ring-k-gray/40"
      data-prevent-cut
    >
      <span
        aria-hidden
        className="absolute inset-y-0 left-0 w-[3px] bg-[var(--td-ink-muted)]"
      />
      <i className="fa-regular fa-house mt-0.5 text-xl text-[var(--td-ink-muted)]" />
      <div>
        <div
          className="text-sm leading-tight"
          style={{ fontFamily: 'var(--td-font-display)' }}
        >
          {message}
        </div>
        {description && (
          <div className="mt-1 text-2xs leading-snug text-[var(--td-ink-soft)]">
            {description}
          </div>
        )}
      </div>
    </div>
  );
}
